
String.format = function () {
    var s = arguments[0]
    for (var i = 0; i < arguments.length - 1; i++) {
        var reg = new RegExp('\\{' + i + '\\}', 'gm')
        s = s.replace(reg, arguments[i + 1])
    }
    return s
}

export function isEmpty (value) {
    return value == null || value.length === 0
}

export let mappingArray = [
    {
        db: 'draft',
        display: 'Draft',
        displayI18n: {
            en: 'Draft',
            'zh-CN': '草稿',
            'zh-TW': '草稿'
        }
    },
    {
        db: 'pendingReview',
        display: 'Waiting for Review',
        displayI18n: {
            en: 'Waiting for review',
            'zh-CN': '等候审查',
            'zh-TW': '等候審查'
        }
    },
    {
        db: 'inReview',
        display: 'In Review',
        displayI18n: {
            en: 'In review',
            'zh-CN': '审查中',
            'zh-TW': '審查中'
        }
    },
    {
        db: 'reviewed',
        display: 'Pending Release',
        displayI18n: {
            en: 'Pending release',
            'zh-CN': '等候发布',
            'zh-TW': '等候發佈'
        }
    },
    {
        db: 'waitingDeveloperPublish',
        display: 'Waiting Developer Publish',
        displayI18n: {
            en: 'Waiting developer publish',
            'zh-CN': '等候开发者发布',
            'zh-TW': '等候開發者發佈'
        }
    },
    {
        db: 'published',
        display: 'Ready for Sale',
        displayI18n: {
            en: 'Ready for sale',
            'zh-CN': '贩售中',
            'zh-TW': '販售中'
        }
    },
    {
        db: 'preOrder',
        display: 'Pre-Order Ready for Sale',
        displayI18n: {
            en: 'Pre-order ready for sale',
            'zh-CN': '预购贩售中',
            'zh-TW': '預購販售中'
        }
    },
    {
        db: 'removed',
        display: 'Removed from Sale',
        displayI18n: {
            en: 'Removed from sale',
            'zh-CN': '已移除',
            'zh-TW': '已移除'
        }
    },
    {
        db: 'rejected',
        display: 'Rejected',
        displayI18n: {
            en: 'Rejected',
            'zh-CN': '已拒绝',
            'zh-TW': '已拒絕'
        }
    },
    {
        db: 'unpublished',
        display: 'Developer Removed from Sale',
        displayI18n: {
            en: 'Developer removed from sale',
            'zh-CN': '开发者移除',
            'zh-TW': '開發者移除'
        }
    },
    {
        db: 'developerRejected',
        display: 'Developer Rejected',
        displayI18n: {
            en: 'Developer rejected',
            'zh-CN': '开发者拒绝',
            'zh-TW': '開發者拒絕'
        }
    }
]
